// Robust copy helper: uses Clipboard API when available, falls back to execCommand
export default function copyToClipboard(text) {
  return new Promise((resolve, reject) => {
    if (!text && text !== '') return reject(new Error('No text to copy'));

    try {
      if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(resolve).catch(() => {
          // fallback
          try {
            fallbackCopy(text);
            resolve();
          } catch (e) { reject(e); }
        });
      } else {
        fallbackCopy(text);
        resolve();
      }
    } catch (err) {
      try { fallbackCopy(text); resolve(); } catch (e) { reject(e); }
    }
  });
}

function fallbackCopy(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  // avoid scrolling to bottom
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const ok = document.execCommand('copy');
  document.body.removeChild(textarea);
  if (!ok) throw new Error('Fallback copy failed');
}
